export const SNAPSHOT = 'snapshot';
export const MANAGE_PLANS_PATH = '/manage_plans';

export const BUNDLE_NAMES = {
  CORE: 'bundle_core',
  GROW: 'bundle_grow',
  SCALE: 'bundle_scale',
} as const;

export const DEFAULT_WORKFLOW_SOURCE = 'bundles_page';

// The exact product names vary based on environment
// but we can search for the inclusion of these strings
export const TEAM_APP_PRODUCT_NAMES = {
  basic: {
    monthly: 'Basic Monthly',
    annual: 'Basic Annual',
  },
  essentials: {
    monthly: 'Essentials Monthly',
    annual: 'Essentials Annual',
  },
  plus: {
    monthly: 'Plus Monthly',
    annual: 'Plus Annual',
  },
  'all-in-one': {
    monthly: 'All-in-One Monthly',
    annual: 'All-in-One Annual',
  },
  enterprise: {
    monthly: 'Enterprise Monthly',
    annual: 'Enterprise Annual',
  },
};
